(() => {
  const money = (cents, currency) => {
    const amount = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat('es-MX', { style: 'currency', currency: currency || 'MXN' }).format(amount); }
    catch (e) { return '$' + amount.toFixed(2); }
  };

  const init = (root) => {
    if (!root || root.dataset.slpReady === 'true') return;
    root.dataset.slpReady = 'true';

    const slides = [...root.querySelectorAll('[data-slp-slide]')];
    const thumbs = [...root.querySelectorAll('[data-slp-thumb]')];
    const bgs = [...root.querySelectorAll('[data-slp-bg]')];
    const hero = root.querySelector('[data-slp-hero]');
    const thumbStrip = root.querySelector('[data-slp-thumbs]');
    const productJson = root.querySelector('[data-slp-product-json]');
    const price = root.querySelector('[data-slp-price]');
    const stock = root.querySelector('[data-slp-stock]');
    const variantInput = root.querySelector('[data-slp-variant-id]');
    const add = root.querySelector('[data-slp-add]');
    const currency = root.dataset.currency || 'MXN';
    let product = null;
    let active = 0;

    try { product = productJson ? JSON.parse(productJson.textContent) : null; } catch (e) { product = null; }

    const centerThumb = (thumb) => {
      if (!thumbStrip || !thumb) return;
      const left = thumb.offsetLeft - ((thumbStrip.clientWidth - thumb.offsetWidth) / 2);
      thumbStrip.scrollTo({ left: Math.max(0, left), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    const show = (index) => {
      if (!slides.length) return;
      active = Math.max(0, Math.min(Number(index) || 0, slides.length - 1));
      slides.forEach((el, i) => el.classList.toggle('is-active', i === active));
      thumbs.forEach((el, i) => {
        el.classList.toggle('is-active', i === active);
        if (i === active) centerThumb(el);
      });
      bgs.forEach((el, i) => el.classList.toggle('is-active', i === active));
      root.dataset.activeSlide = String(active);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => show(thumb.dataset.slpThumb));
    });

    if (hero && window.matchMedia('(pointer:fine)').matches) {
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - .5) * 5;
        const y = ((event.clientY - rect.top) / rect.height - .5) * 4;
        root.style.setProperty('--slp-img-x', x.toFixed(2));
        root.style.setProperty('--slp-img-y', y.toFixed(2));
      });
      hero.addEventListener('pointerleave', () => {
        root.style.setProperty('--slp-img-x', '0');
        root.style.setProperty('--slp-img-y', '0');
      });
    }

    const selectedOptions = () => {
      const groups = [...root.querySelectorAll('[data-option-index]')].filter((el) => el.classList.contains('slp__option'));
      return groups.map((group) => {
        const btn = group.querySelector('.slp__option-btn.is-selected');
        return btn ? btn.dataset.optionValue : '';
      });
    };

    const findVariant = () => {
      if (!product || !product.variants) return null;
      const selected = selectedOptions();
      return product.variants.find((variant) => selected.every((value, index) => String(variant.options[index]) === String(value))) || null;
    };

    const syncPressedState = () => {
      root.querySelectorAll('.slp__option').forEach((group) => {
        group.querySelectorAll('.slp__option-btn').forEach((item) => {
          item.setAttribute('aria-pressed', item.classList.contains('is-selected') ? 'true' : 'false');
        });
      });
    };

    const syncVariant = () => {
      const variant = findVariant();
      syncPressedState();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price, currency);
      if (stock) stock.textContent = variant.available ? 'DISPONIBLE' : 'AGOTADO';
      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? 'AGREGAR AL CARRITO' : 'AGOTADO';
      }
      if (variant.featured_media && variant.featured_media.id) {
        const target = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(variant.featured_media.id));
        if (target >= 0) show(target);
      }
    };

    root.querySelectorAll('.slp__option-btn').forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.classList.contains('is-selected') ? 'true' : 'false');
      btn.addEventListener('click', () => {
        const group = btn.closest('.slp__option');
        if (!group) return;
        group.querySelectorAll('.slp__option-btn').forEach((item) => item.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        syncVariant();
      });
    });

    show(0);
    syncVariant();
  };

  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-slp]').forEach(init));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-slp]').forEach(init));
})();
